<template>
    <div class="download">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="20">
                <el-collapse
                    download
                    v-model="activeNames"
                    @change="handleChange"
                    accordion
                >
                    <el-collapse-item
                        v-for="(item, index) in mainlist"
                        :key="index"
                        :title="item.title"
                        :name="index"
                    >
                        <div>
                            <p class="time">
                                更新时间：<span>{{
                                    item.created | formatDate
                                }}</span>
                                <span class="down"
                                    ><a :href="item.accessory">下载</a></span
                                >
                            </p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="ruleForm.pageIndex"
                    :page-size="ruleForm.pageSize"
                    layout="total,prev, pager, next"
                    :total="ruleForm.total"
                >
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { selectfaq } from "@/api/homePage";
export default {
    name: "download",
    data() {
        return {
            activeNames: [0],
            mainlist: [],
            ruleForm: {
                data: {
                    categoryId: "",
                    platform: "1"
                },
                pageIndex: 1,
                pageSize: 5,
                total: 0
            }
        };
    },
    created() {
        this.ruleForm.data.categoryId = "4";
        this.search(1);
    },
    methods: {
        handleChange() {},
        search(val) {
            this.ruleForm.pageIndex = val;
            selectfaq(this.ruleForm).then(res => {
                if (res.status === 2000) {
                    this.mainlist = res.data.rows;
                    this.ruleForm.total = res.data.total;
                }
            });
        },
        handleCurrentChange(val) {
            this.search(val);
        }
    }
};
</script>

<style scoped lang="scss">
.download {
    .el-row {
        margin-top: 40px;
        margin-bottom: 80px;
        .el-collapse-item__content {
            font-size: 14px;
            .time {
                .down {
                    cursor: pointer;
                    float: right;
                    // margin-right: 40px;3
                    a {
                        color: #000;
                    }
                    a:hover {
                        color: #fabe00;
                    }
                }
            }
        }
    }
    .el-pagination {
        text-align: center;
        margin-top: 30px;
    }
    /deep/ .el-pagination.is-background .el-pager li {
        border-radius: 15px;
    }
    /deep/ .el-pagination.is-background .btn-prev,
    /deep/ .el-pagination.is-background .btn-next {
        border-radius: 15px;
    }
}
</style>
